// ---------------------------------------------------------------------------
// PWA_ControlBillet — Camera overlay for scanner screen
// Semi-transparent dark background with centered scan frame and animated line.
// ---------------------------------------------------------------------------

export function ScanOverlay() {
  return (
    <div className="absolute inset-0 z-10 pointer-events-none flex flex-col items-center justify-center">
      {/* Semi-transparent dark overlay with cutout illusion */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Scan frame area */}
      <div className="relative z-20 flex flex-col items-center">
        {/* Frame container */}
        <div className="relative w-[280px] h-[280px]">
          {/* Corner brackets — top-left */}
          <div className="absolute top-0 left-0 w-10 h-10 border-t-[3px] border-l-[3px] border-white rounded-tl-lg" />
          {/* Corner brackets — top-right */}
          <div className="absolute top-0 right-0 w-10 h-10 border-t-[3px] border-r-[3px] border-white rounded-tr-lg" />
          {/* Corner brackets — bottom-left */}
          <div className="absolute bottom-0 left-0 w-10 h-10 border-b-[3px] border-l-[3px] border-white rounded-bl-lg" />
          {/* Corner brackets — bottom-right */}
          <div className="absolute bottom-0 right-0 w-10 h-10 border-b-[3px] border-r-[3px] border-white rounded-br-lg" />

          {/* Animated scan line */}
          <div className="absolute inset-x-2 top-0 bottom-0 overflow-hidden">
            <div className="absolute left-0 right-0 h-0.5 bg-danger shadow-[0_0_8px_rgba(244,67,54,0.6)] animate-scan-line" />
          </div>
        </div>

        {/* Instruction text */}
        <p className="mt-6 text-white/80 text-sm font-medium text-center px-4">
          Placez le QR code dans le cadre
        </p>
      </div>
    </div>
  );
}
